import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsPicItemClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/pic-item');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic-item ');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/pic-item/', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic-item ');
    }
  }

  async store(data) {
    try {
      return await this.api.post('/pic-item', data);
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Pic-item ');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/pic-item/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Pic-item ');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/pic-item/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Pic-item ');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.api.post('/pic-item/delete', body);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Pic-item ');
    }
  }
}
